import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type ListFilter } from '../types/filters';

export const genderDefinition: FilterDefinition<ListFilter> = {
  id: FilterId.GENDER,
  name: 'Gender',
  selectionListId: 'gender',
  selections: [],
  type: FilterType.LIST,
  isVisible: true,
};

export const genderHandler: FilterHandler<ListFilter> = {
  isActive(currentFilterState: ListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: ListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: ListFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<ListFilter>) {
    return [definition.selectionListId];
  },
};
